module.exports = __webpack_public_path__ + "img/dm.e45b0ea3.png";